import { DocumentCardView } from "./view/documentCardView";
import { NB_DocumentCardProps } from "./types/documentCard.type";

export const Nb_DocumentCard = ({ ...props }: NB_DocumentCardProps) => {
  return (<DocumentCardView {...props} />);
};
